export default "__VITE_ASSET__DI9KPsFw__"